import {Field} from "./field";
import {Components, FieldPersonas} from "../../../../interfaces/personas-proyecto.interface";

export class DropdownField extends Field<string> {
    constructor(options: any = {}) {
        super({...options, controlType: 'dropdown'});
    }
}

export class TextboxField extends Field<string> {
    constructor(options: any = {}) {
        super({...options, controlType: 'textbox'});
    }
}

export class MultiSelectField extends Field<string[]> {
    constructor(options: any = {}) {
        super({...options, controlType: 'multiselect'});
    }
}

export function transformJsonToForm(json: any[]): Field<any>[] {
    return json.map((item) => {
        switch (item.type) {
            case 'textbox':
                return new TextboxField({
                    step:item.step,
                    key: item.key,
                    label: item.label,
                    required: item.required,
                    disabled: item.disabled,
                    completed: item.completed,
                    order: item.order,
                    type: item.type,
                    value: item.value,
                });
            case 'dropdown':
                return new DropdownField({
                    step:item.step,
                    key: item.key,
                    label: item.label,
                    required: item.required,
                    disabled: item.disabled,
                    completed: item.completed,
                    order: item.order,
                    type: item.type,
                    options: item.options,
                    values: Array.isArray(item.values) ? item.values : item.values ? [item.values] : [],
                });
            case 'multiselect':
                return new MultiSelectField({
                    step:item.step,
                    key: item.key,
                    label: item.label,
                    required: item.required,
                    disabled: item.disabled,
                    completed: item.completed,
                    order: item.order,
                    type: item.type,
                    options: item.options,
                    values: Array.isArray(item.values) ? item.values : item.values ? [item.values] : [],
                });
            default:
                return new Field({
                    key: item.key,
                    label: item.label,
                    required: item.required,
                    disabled: item.disabled,
                    completed: item.completed,
                    order: item.order,
                    type: item.type,
                    options: item.options,
                    value: item.value,
                });
        }
    });
}

export function transformFormToJson(formValues: any, originalFields: Field<any>[]
): any[] {
    return originalFields.map((field) => {
        const rawValue = formValues[field.key];
        switch (field.controlType) {
            case 'textbox':
                return {
                    key: field.key,
                    label: field.label,
                    required: field.required,
                    disabled: (rawValue != null),
                    completed: (rawValue != null),
                    order: field.order,
                    type: 'textbox',
                    value: rawValue || '',
                };
            case 'dropdown':
                return {
                    key: field.key,
                    label: field.label,
                    required: field.required,
                    disabled: (rawValue != null),
                    completed: (rawValue != null),
                    order: field.order,
                    type: 'dropdown',
                    options: field.options,
                    value: '',
                    values: Array.isArray(rawValue) ? rawValue : rawValue ? [rawValue] : [],
                };
            case 'multiselect':
                return {
                    key: field.key,
                    label: field.label,
                    required: field.required,
                    disabled: (rawValue != null),
                    completed: (rawValue != null),
                    order: field.order,
                    type: 'multiselect',
                    options: field.options,
                    value: '',
                    values: Array.isArray(rawValue) ? rawValue : rawValue ? [rawValue] : [],
                };
            default:
                return {
                    key: field.key,
                    label: field.label,
                    required: field.required,
                    disabled: (rawValue != null),
                    completed: (rawValue != null),
                    order: field.order,
                    type: field.controlType,
                    options: field.options || [],
                    value: rawValue || '',
                    values: [],
                };
        }
    });
}


export function transformJsonToFormPersonas(parsedPayload: any): FieldPersonas<string>[] {
    return parsedPayload.map((item: any) => {
        const components: Components[] = (item.components || []).map((component: any) => ({ // Mapeando los componentes del payload a instancias de la interfaz Components
            key: component.key || '',
            label: component.label || '',
            placeholder: component.placeholder || '',
            required: component.required || false,
            disabled: component.disabled || false,
            completed: component.completed || false,
            order: component.order || 0,
            controlType: component.controlType || '',
            type: component.type || '',
            options: component.options || [],
            values: component.values || [],
        }));

        return new FieldPersonas<string>({// Nueva instancia de FieldPersonas
            step: item.step || 0,
            titulo: item.titulo || '',
            subtitulo: item.subtitulo || '',
            placeholder: item.placeholder || '',
            typeStep: item.typeStep || '',
            components: components,
            pieValidTable: item.pieValidTable || '',
            disableComponent: item.disableComponent || false,
        });
    });
}
